import { render, staticRenderFns } from "./fooddetails.vue?vue&type=template&id=177ffc46&scoped=true&"
import script from "./fooddetails.vue?vue&type=script&lang=js&"
export * from "./fooddetails.vue?vue&type=script&lang=js&"
import style0 from "./fooddetails.vue?vue&type=style&index=0&id=177ffc46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ffc46",
  null
  
)

export default component.exports